<template>
	<b-field expanded :type="enableValidation && $v.selectedValue.$dirty ? (($v.selectedValue.$invalid) ? 'is-danger' : 'is-success') : ''">
		<template #label>
			<div class="align-content-center select-label-row">
				<p> {{ labelText }}</p>
				<span class="tag is-danger is-light select-required-badge"
					v-if="enableValidation && $v.selectedValue.$invalid">
					{{ validationMessage }}
				</span>
			</div>
		</template>
		<b-autocomplete class="autocomplete_break" open-on-focus clearable v-model="inputString" :data="orderedFilteredDataArray" icon="magnify"
			:custom-formatter="option => (option?.attributes.number + ': ' + getDoctorName(option?.attributes?.doctor) + ', ' +
		option?.attributes.date.toLocaleDateString('de-DE', {
			year: 'numeric',
			month: '2-digit',
			day: '2-digit',
		}) + ', ' + getDiagnoseName(option?.attributes?.diagnose))" @select="option => set(option)">

			<template slot-scope="props">
				<div class="media">
					<div class="media-content">
						{{ props?.option?.attributes.number + ': ' + getDoctorName(props?.option?.attributes?.doctor) +
		', ' +
		props?.option?.attributes.date.toLocaleDateString('de-DE', {
			year: 'numeric',
			month: '2-digit',
			day: '2-digit',
		}) + ', ' + getDiagnoseName(props?.option?.attributes?.diagnose) }}
					</div>
				</div>
			</template>

			<template #empty>Keine Ergebnisse gefunden.</template>
		</b-autocomplete>
	</b-field>
</template>

<script>
import { mapGetters } from "vuex";
import { requiredIf } from "vuelidate/lib/validators";

export default {
	name: "MedicationReportSearchableSelect",
	props: [
		"editObject",
		"select",
		"dataOptions",
		"enableValidation",
		"validationMessage",
		"labelText",
		"enableOrder"
	],
	data() {
		return {
			inputString: '',
			selectedValue: undefined
		}
	},
	validations: {
		selectedValue: {
			required: requiredIf(function (enableValidation) {
				return enableValidation
			}),
		},
	},
	mounted() { },
	computed: {
		...mapGetters({
			doctorArray: "doctors/getData",
			diagnoseArray: "diagnoses/getData",
		}),
		orderedFilteredDataArray() {
			if (this.enableOrder) {
				let sortedArray = this.filteredDataArray
				return sortedArray.sort((a, b) =>
					(a.attributes.number > b.attributes.number) ? 1
						: ((b.attributes.number > a.attributes.number) ? -1 : 0));
			}
			else {
				return this.filteredDataArray
			}
		},
		filteredDataArray() {
			let returnVal = this.dataOptions.filter((element) => {
				let searchString = element.attributes.number + " " + (this.getDoctorName(element.attributes.doctor)).toLowerCase() + " " + element.attributes.date.toLocaleDateString('de-DE', {
					year: 'numeric',
					month: '2-digit',
					day: '2-digit',
				}) + (this.getDiagnoseName(element.attributes.diagnose)).toLowerCase()
				return searchString.indexOf((this.inputString.toLowerCase())) >= 0
			})
			return returnVal
		}
	},
	methods: {
		getDoctorName(doctorObject) {
			let doctorValue = doctorObject;
			if (doctorValue && doctorValue.__type == 'Pointer') {
				doctorValue = this.doctorArray.find((element) => this.doctorValue.objectId == element.id)
			}
			return doctorObject.attributes.name
		},
		getDiagnoseName(diagnoseObject) {
			let diagnoseValue = diagnoseObject;
			if (diagnoseValue && diagnoseValue.__type == 'Pointer') {
				diagnoseValue = this.diagnoseArray.find((element) => this.diagnoseValue.objectId == element.id)
			}
			return diagnoseValue.attributes.name
		},
		set(option) {
			this.$v.selectedValue.$touch();
			if (option) {
				this.select(option.toPointer())
			}
			if (option == null) {
				this.selectedValue = undefined
			}
		}
	},
	watch: {
		editObject(newValue) {
			if (newValue) {
				this.selectedValue = this.orderedFilteredDataArray.find((element) => this.editObject.objectId == element.id)
				this.inputString = this.selectedValue.attributes.number + ": " + this.getDoctorName(this.selectedValue.attributes.doctor) + ', ' +
					this.selectedValue.attributes.date.toLocaleDateString('de-DE', {
						year: 'numeric',
						month: '2-digit',
						day: '2-digit',
					}) + ', ' + this.getDiagnoseName(this.selectedValue.attributes.diagnose)
			}
		}
	}
}
</script>

<style lang="scss">

.autocomplete_break.autocomplete .dropdown-item, 
.autocomplete_break.autocomplete .dropdown .dropdown-menu .has-link a
{
	white-space: wrap;
}

.autocomplete_break.autocomplete .dropdown-item .media-content span
{
	display:inline;
}
</style>